"use strict";
exports.__esModule = true;
// Game
var Main_1 = require("./Main");
// Style
require("./style/layout.less");
document.getElementById("year").innerText = new Date().getFullYear().toString();
// Setup the game
new Main_1["default"]();
